import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=a5c6aa7c&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=ts"
export * from "./ChatWindow.vue?vue&type=script&lang=ts"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=a5c6aa7c&prod&lang=scss&scoped=true"
import style1 from "./ChatWindow.vue?vue&type=style&index=1&id=a5c6aa7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c6aa7c",
  null
  
)

export default component.exports